<template>
  <div class="register-page">
    <div class="top"><a class="logo-img" href="#/"></a></div>
    <div class="banner"></div>
    <div class="step-content clearfix">
      <!-- <Steps :current="step">
          <Step title="01" content="手机验证码"></Step>
          <Step title="02" content="信息录入"></Step>
          <Step title="03" content="注册成功"></Step>
      </Steps> -->
      <div class="step-info">
        <p class="title active">01</p>
        <p class="content active">手机验证码</p>
      </div>
      <div class="line" :class="[step>=2 ? 'active' : '']"></div>
      <div class="step-info">
        <p class="title" :class="[step>=2 ? 'active' : '']">02</p>
        <p class="content" :class="[step>=2 ? 'active' : '']">信息录入</p>
      </div>
      <div class="line" :class="[step>=3 ? 'active' : '']"></div>
      <div class="step-info">
        <p class="title" :class="[step>=3 ? 'active' : '']">03</p>
        <p class="content" :class="[step>=3 ? 'active' : '']">注册成功</p>
      </div>
    </div>
    <div class="register-content">
      <div v-if="step==1" class="register-form">
        <Form :label-width="0" ref="registerForm" :model="formValidate" :rules="ruleValidate">
            <p class="title">手机号</p>
            <FormItem prop="phone">
              <Input @on-enter="nextStep" size="large" v-model="formValidate.phone"></Input>
            </FormItem>
            <p class="title">验证码</p>
            <FormItem prop="obj" style="position: relative;">
                <!-- <Input size="large" @on-enter="nextStep" v-model="formValidate.veriImage" :maxlength="8">
                </Input>
                <div class="form-verify-img"><img :src="vImg" @click="setVerifyImg" /></div> -->
                <ali-yun-check @getCheck="getCheck"></ali-yun-check>
            </FormItem>
            <p class="title">手机验证码</p>
            <FormItem prop="verifyCode" style="position: relative;">
                <Input size="large" @on-enter="nextStep" v-model="formValidate.verifyCode" :maxlength="8">
                </Input>
                <div class="phone-img-wrap">
                  <a v-if="!sending" href="javascript:;" @click="sendRegisterCode">发送验证码</a>
                  <a v-else class="unsend" href="javascript:;">重新发送 {{seconds}}</a>
                </div>
            </FormItem>
        </Form>
        <div class="reg-agree">
            注册代表你已经同意&nbsp;<a href="//info.hunteron.com/protocol/pc/hr.html" target="_blank">猎上用户协议</a>
        </div>
        <Button type="primary" style="width:340px;margin-top:10px;font-size:16px;" :loading="!!submitting" @click="nextStep" size="large">下一步</Button>
        <div class="has-account">
            已有账号，<a target="_blank" href="#/">立即登录</a>
        </div>
      </div>
      <div v-if="step==2">
        <div v-if="!emailSuccess" class="register-form">
          <Form :label-width="0" ref="registerForm2" :model="formValidate2" :rules="ruleValidate2">
            <p class="title">手机号</p>
            <FormItem prop="phone">
              <Input @on-enter="nextStep2" size="large" disabled v-model="formValidate2.phone"></Input>
            </FormItem>
            <p class="title">登录密码</p>
            <FormItem prop="password1">
              <Input @on-enter="nextStep2" @on-focus="beforeFocusType='password'" size="large" :type="beforeFocusType" v-model="formValidate2.password1" :maxlength="20" :minlength="6"></Input>
            </FormItem>
            <p class="title">确认密码</p>
            <FormItem prop="password2">
              <Input @on-enter="nextStep2" @on-focus="beforeFocusType='password'" size="large" :type="beforeFocusType" v-model="formValidate2.password2" :maxlength="20" :minlength="6"></Input>
            </FormItem>
            <p class="title">企业名称</p>
            <FormItem prop="enterpriseName">
              <Input @on-enter="nextStep2" :maxlength="60" size="large" :disabled="eNameDisabled" v-model="formValidate2.enterpriseName"></Input>
            </FormItem>
            <p class="title">联系人姓名</p>
            <FormItem prop="realName">
              <Input @on-enter="nextStep2" :maxlength="50" size="large" v-model="formValidate2.realName"></Input>
            </FormItem>
            <!-- <p class="title">绑定企业后缀邮箱</p>
            <FormItem prop="email">
              <Input @on-enter="nextStep2" size="large" v-model="formValidate2.email"></Input>
            </FormItem> -->
          </Form>
          <Button type="primary" style="width:340px;margin-top:10px;font-size:16px;" :loading="!!submitting" @click="nextStep2" size="large">注册</Button>
        </div>
        <div v-if="emailSuccess" class="register-message">
          <p><i class="iconfont icon-emizhifeiji"></i><p>
          <p>我们已经发送了一封验证邮件至您的邮箱&nbsp;<a :href="'mailto:'+formValidate.phone">1256109499@qq.com</a></p>
          <p>请在24小时内完成验证</p>
        </div>
      </div>
      <div v-if="step==3" class="register-success">
          <h2 class="title clearfix"><i class="iconfont icon-gou"></i><span class="text">注册成功</span></h2>
          <p class="i-qa">如果有任何问题可以通过以下方式联系我们</p>
          <p class="i-tel">电话：021-80250888</p>
          <p class="i-mail">邮箱：<a href="mailto:customercare@hunteron.com">customercare@hunteron.com</a></p> 
          <p class="i-time"><span>{{remaining}}</span>秒后自动跳转首页</p>
      </div>
    </div>
  </div>
</template>

<script>

import DB from '@/common/db'
import MD5 from '@/common/md5'


export default {
  name: 'register',
  data () {
    const validatePhone =( rule ,value , cb) =>{
        if(!value){
          return cb(new Error('请填写手机号'));
        }
        if(!this.phoneReg.test(value)){
          return cb(new Error('请填写正确的格式'));
        }
        return cb();
    };
    const validateEmail =( rule ,value , cb) =>{
        if(!value){
          return cb(new Error('请填写企业后缀邮箱'));
        }
        if(!this.emailReg.test(value)){
          return cb(new Error('请填写正确的格式'));
        }
        return cb();
    };
    const validatePass = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请填写密码'));
        } else if(!/^[^\s]*$/.test(value)){
            callback(new Error('密码不允许含空格'));
        } else if(value.length < 6){
            callback(new Error('密码不能少于6位'));
        } else{
          if (this.formValidate2.password2 !== '') {
              // 对第二个密码框单独验证
              this.$refs.registerForm2.validateField('password2');
          }
          callback();
        }
    };
    const validatePassCheck = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请填写确认密码'));
        } else if(!/^[^\s]*$/.test(value)){
            callback(new Error('密码不允许含空格'));
        } else if(value.length < 6){
            callback(new Error('密码不能少于6位'));
        } else if (value !== this.formValidate2.password1) {
            callback(new Error('两次密码输入不一致'));
        } else {
            callback();
        }
    };
    return {
      vImg:null,
      sending: false,
      seconds: 0,
      isShowPhone: false,
      beforeFocusType: 'text',  //为了阻止浏览器自动填充功能
      phoneReg:  /^1[0-9]{10}$/,
      emailReg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
      step: this.$route.query.step ? ~~this.$route.query.step : 1,
      authCode: this.$route.query.authCode ? this.$route.query.authCode : '',
      uuid: this.$route.query.uuid ? this.$route.query.uuid : '',
      saleAdmin: this.$route.query.saleAdmin ? this.$route.query.saleAdmin : '',
      emailSuccess: false,
      phone: this.$route.query.phone ? this.$route.query.phone : '',
      eNameDisabled: false,
      remaining: 5,
      formValidate:{
        phone: this.$route.query.phone ? this.$route.query.phone : '',
        veriImage: null,
        verifyCode: null,
        obj: null
      },
      formValidate2:{
          phone: this.$route.query.phone ? this.$route.query.phone : '',
          password1: null,
          password2: null,
          enterpriseName: null,
          realName: null,
          email: null
      },
      ruleValidate:{
        phone:[
          {validator: validatePhone, trigger: 'blur'}
        ],
        // veriImage:{type:'string', required: true, message: '请填写图片验证码', trigger: 'blur' },
        obj:{required: true, message: '请滑动验证码'},
        verifyCode:{ type:'string', required: true, message: '请填写手机验证码', trigger: 'blur' }
      },
      ruleValidate2:{
        password1:[
            {validator: validatePass, trigger: 'blur' }
        ],
        password2:[
            {validator: validatePassCheck, trigger: 'blur' }
        ],
        enterpriseName:{type:'string', required: true, message: '请输入企业名称', trigger: 'blur' },
        realName:{type:'string', required: true, message: '请输入联系人姓名', trigger: 'blur' }
        // email:{validator: validateEmail, trigger: 'blur' },
      },
      submitting: null
    }
  },
  methods:{
    getCheck(data){
      this.formValidate.obj = data && Object.keys(data).length ? {...data} : null;
      if(this.formValidate.obj){
        this.$refs.registerForm.validateField("obj");
      }
    },
    setVerifyImg(){
      // this.vImg = DB.prefix + 'common/v2/imageVerCode?st='+ new Date().getTime();
      if(window.nc){
              window.nc.reset();
            }
    },
    sendRegisterCode(){
      if(this.seconds > 0){
          return;
      }
      if(!this.formValidate.phone || !this.phoneReg.test(this.formValidate.phone)) {
        this.$refs.registerForm.validateField('phone');
        return;
      }
      if(!this.formValidate.obj || !Object.keys(this.formValidate.obj).length){
        this.$refs.registerForm.validateField('obj');
        return;
      }
      this.seconds = 30;
       DB.request({
          url: DB.prefix + 'auth/v2/sendRegistPhone',
          type:"post",
          showMessage: false,
          data: {
              phone: this.formValidate.phone,
              ...this.formValidate.obj,
              // imageVeriCode: this.formValidate.veriImage,
              t:new Date().getTime()
          },
          success:(res)=>{
            this.sending = true;
            let intervalTimer = setInterval(()=>{
                this.seconds--;
                if(this.seconds < 1){
                    this.sending = false;
                    clearInterval(intervalTimer);
                }
            },1000);
          },
          error:()=>{
            this.seconds = 0;
            this.setVerifyImg();
          },
          complete:()=>{
          }
      });
    },
    nextStep(){
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.submitting = true;
          DB.request({
            url: DB.prefix + 'auth/v2/validateRegistPhone',
            type:'POST',
            data:{
              phone: this.formValidate.phone,
              // imageVeriCode_tel: this.formValidate.veriImage,
              ...this.formValidate.obj,
              authCode: this.formValidate.verifyCode,
              t: new Date().getTime(),
              saleAdmin: this.saleAdmin
            },
            success:(res)=>{
              this.$router.push({query: {...this.$route.query, step:2, authCode: this.formValidate.verifyCode, phone: this.formValidate.phone}});
              this.step = 2;
              this.formValidate2.phone = this.formValidate.phone;
              this.phone = this.formValidate.phone;
              this.authCode = this.formValidate.verifyCode;
            },
            error:()=>{
              this.setVerifyImg();
            },
            complete:()=>{
              this.submitting = false;
            }
          });
        }
      });
    },
    nextStep2(){
      this.$refs['registerForm2'].validate((valid) => {
        if (valid) {
          this.submitting = true;
          let params = {
            phone: this.formValidate2.phone,
            password: MD5(this.formValidate2.password1),
            realName: this.formValidate2.realName,
            authCode: this.authCode,
            saleAdmin: this.saleAdmin,
            isPhoneValidate: true,
            isEmailValidate: false
            // email: this.formValidate2.email
          };
          if(this.uuid){
            params.uuid = this.uuid;
          }else{
            params.enterpriseName = this.formValidate2.enterpriseName;
          }
          DB.request({
              url: DB.prefix + 'auth/v2/register',
              type:'post',
              data: params,
              success:(data)=>{
                // this.emailSuccess = true;
                this.step = 3;
                this.triggerTimer();
              },
              complete:()=>{
                this.submitting = false;
              }
          });
        }
      });
    },
    triggerTimer(){
      this.remaining = 5;
      let t = setInterval(()=>{
          this.remaining--;
          if(this.remaining<1){
              clearInterval(t);
              location.href = '/index.html#/';
              return;
          }
      }, 1000);
    }
  },
  components:{
    'aliYunCheck': resolve => require(['@/components/aliYunCheck'], resolve)
  },
  created(){
    DB.request({
      url: DB.prefix + 'auth/v2/link',
      type:'get',
      success:(data)=>{
        if(this.step==1){
          this.setVerifyImg();
        }
      },
      error:()=>{
      }
    });
    if(this.step ==2 && (!this.phone || !this.authCode)){
      this.$Modal.error({
        content: '请通过正规途径使用此产品!',
        onOk: () => {
          this.$Modal.remove();
          location.href="#/";
        }
      });
    }
    if(this.step == 2 && this.phone){
      DB.request({
          url: DB.prefix + 'auth/v2/validateRegistPhone',
          type: 'POST',
          data: {
            phone: this.phone,
            authCode: this.authCode
          },
          showMessage: false,
          error: (data) =>{
            this.$Modal.error({
              content: data.message,
              onOk: () => {
                this.$Modal.remove();
                location.href="#/";
              }
            });
            return false;
          }
      });
    }
    if(this.uuid){
      DB.request({
          url: DB.prefix + 'ucenter/v2/getRegdomain',
          data:{
            uuid: this.uuid
          },
          success: (data) =>{
            if(data.data && data.data.displayName){
              this.formValidate2.enterpriseName = data.data.displayName;
              this.eNameDisabled = true;
            }
          },
          error: () =>{
              this.uuid = '';
          }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
<style lang="scss" scoped>
  .register-page{
    background: #fff;
    min-height: 100vh;
  }
  .top{
    width: 1200px;
    margin: 0 auto;
    height: 56px;
    background: url('../../assets/top-bg.png') 0 center no-repeat;
    position: relative;
    .logo-img{
      width: 240px;
      height: 40px;
      display: inline-block;
      margin-top: 8px;
    }
  }
  .banner{
    width: 100%;
    height: 120px;
    background: url('../../assets/banner1.jpg') no-repeat center top #000;
  }
  .step-content{
    width: 550px;
    margin: 40px auto;
    .step-info{
      float: left;
      margin: 0 10px;
      text-align: center;
      .title{
        color: #808190;
        font-size: 24px;
        &.active{
          color: #2D8CF0;
        }
      }
      .content{
        color: #B1B0BF;
        font-size: 14px;
        &.active{
          color: #333;
        }
      }
    }
    .line{
      float: left;
      width: 130px;
      height: 1px;
      margin-top: 18px;
      background-color: #DDDEE1;
      &.active{
        background-color: #2D8CF0;
      }
    }
  }
  .register-content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    position: relative;
    .reg-agree{
      margin: 20px 0 10px;
      color: #999;
      a{
        color: #2d8cf0;
      } 
    }
    .has-account{
      margin: 20px 0;
      color: #333;
      a{
        color: #2d8cf0;
      } 
    }
    .register-success{
      width: 400px;
      margin: 60px 0 0 380px;
      color: #495060;
      font-size: 14px;
      .title{
        .icon-gou{
          color: #2EA1F8;
          font-size: 42px;
          margin-right: 15px;
          float: left;
        }
        .text{
          color: #333;
          font-size: 36px;
          float: left;
          margin-top: 3px;
        }
      }
      .i-qa{
        margin: 25px 0 0 60px;
      }
      .i-tel{
        margin: 25px 0 0 60px;
      }
      .i-mail{
        margin: 10px 0 0 60px;
      }
      .i-time{
        margin: 25px 0 0 60px;
        span{
          color: #EE4014;
        }
      }
    }
    .register-message {
      width: 100%;
      margin: 80px auto;
      p{
        text-align: center;
        margin-bottom: 10px;
        font-size: 18px;
        .icon-emizhifeiji{
          font-size: 80px;
          color: #2d8cf0;
        }
      }
    }
    .register-form {
      width:340px;
      margin-left: 380px;
    }
    .form-verify-img {
      display:inline-block;
      height:25px;
      overflow: hidden;
      position: absolute;
      right: 10px;
      top: 6px;
      img {
        height:25px;
        display:inline-block;
      }
    }
    .phone-img-wrap{
      position: absolute;
      right: 10px;
      top: 0;
      a{
        line-height: 35px;
        color: #2d8cf0;
        display: inline-block;
        height: 35px;
      }
      .unsend{
        cursor: not-allowed;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue